import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'app-v2/design-systems/theme'

export const Status = ({
    color = colors.crunchyGreen,
    size = 10,
    className = 'status'
}: Icon) => (
    <svg className={className} width={size} height={size}>
        <circle
            cx={5}
            cy={5}
            r={4.75}
            fill={color}
            stroke="white"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
)
